/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/arrow-down-2': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" d="M7.092 14l6.363-5.916V4.74L8.364 9.473V0H5.818v9.473L.728 4.739v3.345L7.091 14z" _fill="#fff"/>'
  }
})
